import {
  HermesProfileCatalogSchema,
  HermesProfileMutationResponseSchema,
  type CreateHermesProfileRequest,
} from "@herskin/contracts";
import { api } from "./api";

export const HERMES_PROFILES_UPDATED_EVENT = "herskin:hermes-profiles-updated";

export async function loadHermesProfiles() {
  return HermesProfileCatalogSchema.parse(await api<unknown>("/api/hermes/profiles"));
}

export async function createHermesProfile(input: CreateHermesProfileRequest) {
  const result = HermesProfileMutationResponseSchema.parse(
    await api<unknown>("/api/hermes/profiles", {
      method: "POST",
      body: JSON.stringify(input),
    }),
  );
  window.dispatchEvent(new Event(HERMES_PROFILES_UPDATED_EVENT));
  return result;
}

export async function updateHermesProfileDescription(name: string, description: string) {
  const result = HermesProfileMutationResponseSchema.parse(
    await api<unknown>(`/api/hermes/profiles/${encodeURIComponent(name)}/description`, {
      method: "PUT",
      body: JSON.stringify({ description }),
    }),
  );
  window.dispatchEvent(new Event(HERMES_PROFILES_UPDATED_EVENT));
  return result;
}
